import React, {useContext, useEffect, useState} from 'react';
import styles from './EditNews.module.css'
import {Button, Card, Container, Spinner,} from "react-bootstrap";
import {Context} from "../../../index";
import swal from 'sweetalert';
import {observer} from 'mobx-react-lite';
import ModalCreateAndUpdateNews from "../../../components/modals/modalNewsEditor/modalCreateAndUpdateNews";
import PostBody from "../../../components/postBody/postBody";
import ErrorPage from "../../ErrorPage/ErrorPage";
import PaginationBlock from "../../../components/Pagination/PaginationBlock";
import {EDIT_NEWS_ROUTE} from "../../../utils/const";

const EditNews = observer(() => {
    const {posts} = useContext(Context);
    const {global} = useContext(Context);
    global.setIsAdminPage(true);
    const [show, setShow] = useState(false);
    const [modalType, setModalType] = useState('create');
    const [isPostsLoaded, setIsPostsLoaded] = useState(false);

    const [pageNumber, setPageNumber] = useState(window.location.search.split('=')[1] ?? '');

    useEffect(() => {
        setIsPostsLoaded(false);
        posts.loadPosts(pageNumber).then(() => setIsPostsLoaded(true));
    }, [pageNumber])

    if (posts.error) {
        return <ErrorPage/>
    }

    const showAlert = () => {
        swal({
            title: "Вы уверены, что хотите удалить пример работ?",
            icon: "warning",
            buttons: {
                cancel: "Нет, не удалять",
                catch: {
                    text: "Да, удалить!",
                    value: "Да, удалить!",
                },
            },
        })
            .then(async (value) => {
                switch (value) {

                    case "Да, удалить!":
                        if (await posts.deletePost()) {
                            swal("Успешно удалено", "Пример работ успешно удалён", "success");
                        } else {
                            swal("Ошибка!", posts.errorMessage, "error");
                        }
                        break;
                    default:
                        break;
                }
                <br/>
            });
    }

    return (
        <>
            {
                isPostsLoaded ?
                    <>
                        <Container className={styles.container}>
                            <Button className={styles.createPost} type='submit' onClick={
                                () => {
                                    setShow(true);
                                    setModalType('create')
                                }
                            }>
                                Создать пример работ
                            </Button>
                            {isPostsLoaded ? posts.posts.map((el, index) => (
                                <Card className={styles.card}>
                                    <PostBody data={el} index={index} key={index} showText={false}/>
                                    <div className={styles.buttons}>
                                        <Button className={styles.deletePost} type='submit' onClick={
                                            () => {
                                                posts.setEditingPostId(el.id);
                                                showAlert();
                                            }
                                        }>
                                            Удалить пример работ
                                        </Button>
                                        <Button className={styles.editPost} type='button' onClick={
                                            () => {
                                                posts.setEditingPostId(el.id);
                                                posts.setEditingPost(el);
                                                posts.setCurrentHeader(el.header);
                                                posts.setCurrentCategory(el.category);
                                                setModalType('update');
                                                setShow(true);
                                            }
                                        }>
                                            Редактировать пример работ
                                        </Button>
                                    </div>
                                </Card>
                            )) : ''}
                            <ModalCreateAndUpdateNews show={show} type={modalType} onHide={() => setShow(false)}/>
                        </Container>
                        <div className={styles.pagination}>
                            <PaginationBlock count={posts.pagination.count} current={posts.pagination.current}
                                             route={EDIT_NEWS_ROUTE} setPageNumber={setPageNumber}/>
                        </div>
                    </>
                    :
                    <Spinner className="spinner" animation={"grow"}/>
            }
        </>
    );
});

export default EditNews;
